module.exports = __webpack_public_path__ + "static/media/cuisne_salle_a_manger.83c9fdc6.jpg";